import { useEffect, useMemo } from 'react';
import { getFilterValuesAsString } from 'src/common/Breadcrumb/getFilterValuesAsString';
import { Filter, FilterConfig } from 'src/utils/composeFilter.ts';
import { NavigateFunction } from 'react-router-dom';
import { PATHS } from 'src/router';

export function useCheckMainFilter({
    filter,
    filterConfig,
    navigate,
    searchParams,
}: {
    filter: Filter;
    filterConfig: FilterConfig | null;
    navigate: NavigateFunction;
    searchParams: URLSearchParams;
}): boolean {
    useEffect(() => {
        // no main filter - redirect
        const isMainFilterMalformed = Object
            .keys(filter)
            .length === 0;
        if (isMainFilterMalformed) {
            navigate({
                pathname: `${PATHS.Home}`,
                search: searchParams.toString(),
            });
        }
    }, [filter, navigate, searchParams]);

    return useMemo(
        () => {
            if (filterConfig === null) {
                return false;
            }
            return getFilterValuesAsString(filterConfig, filter).length > 0;
        },
        [filterConfig, filter],
    );
}
